import { Icon, IconSize } from '@bechtel/gds';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { ButtonStyled } from './styled';

export const ButtonCellRenderer = (props: ICellRendererParams) => {
  const { colDef } = props;
  // getting editable & callback parameter from cell editor params for edit list
  const editable =
    colDef?.editable ||
    (colDef?.cellEditorParams &&
      typeof colDef?.cellEditorParams === 'function' &&
      colDef?.cellEditorParams(props).editable);

  const onClickEdit =
    colDef?.cellEditorParams &&
    typeof colDef?.cellEditorParams === 'function' &&
    colDef?.cellEditorParams(props).onClick;

  return (
    <ButtonStyled
      editable={editable}
      onClick={() => {
        onClickEdit(props);
      }}
    >
      <Icon icon="pen-to-square" iconStyle="regular" fillColor="white" size={IconSize.XSMALL} />
    </ButtonStyled>
  );
};
